import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableCell, TableHead, TableRow, TableBody, useMediaQuery, Theme } from '@mui/material';
import { Order } from 'models/order';
import { OrderItemContext, OrderItemEvent } from 'models/order-item-events';
import DentistOrderItem from './dentist-order-item.component';

type DentistOrderTableProps = {
    orders: Order[];
    onOrderItemEvent: (event: OrderItemEvent) => void;
    onContextMenu: (orderContext: OrderItemContext) => void;
    batchActionSelected?: boolean;
    onHandleCheckedOrders?: (order: Order, checked: boolean, orderIndex: number) => void;
    isAtLimit?: boolean;
    checkedOrderIds?: Set<string>;
};
const DentistOrderTable: FC<DentistOrderTableProps> = ({
    orders,
    onOrderItemEvent,
    onContextMenu,
    batchActionSelected,
    onHandleCheckedOrders,
    isAtLimit,
    checkedOrderIds,
}: DentistOrderTableProps) => {
    const { t: translate } = useTranslation(['orders', 'common']);
    const isLargeScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

    return (
        <Table size={!isLargeScreen ? 'small' : 'medium'}>
            <TableHead>
                <TableRow>
                    {batchActionSelected ? <TableCell width="1"></TableCell> : undefined}
                    <TableCell width="1">{!isMobile ? <span>{translate('common:STATUS')}</span> : undefined}</TableCell>
                    <TableCell>{translate('common:PATIENT')}</TableCell>
                    <TableCell>{translate('orders:CONSTRUCTIONS')}</TableCell>
                    <TableCell>{translate('common:DENTIST')}</TableCell>
                    <TableCell>{translate('common:LAB')}</TableCell>
                    <TableCell>{translate('common:CREATED')}</TableCell>
                    <TableCell>{translate('orders:DELIVERY')}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            {orders ? (
                <TableBody>
                    {orders.map((order, orderIndex) => (
                        <DentistOrderItem
                            key={order._id}
                            order={order}
                            onOrderContextMenu={onContextMenu}
                            onOrderItemEvent={onOrderItemEvent}
                            batchActionSelected={batchActionSelected}
                            onHandleCheckedOrders={onHandleCheckedOrders}
                            orderIndex={orderIndex}
                            isAtLimit={isAtLimit}
                            isChecked={checkedOrderIds?.has(order._id as string) ?? false}
                        />
                    ))}
                </TableBody>
            ) : undefined}
        </Table>
    );
};

export default DentistOrderTable;
